import { merge } from 'lodash';
import { DEFAULTS } from './video-component.js';
import { Node_Type } from 'wix-rich-content-common';
import { convertNodeDataToDraft } from 'ricos-content/libs/toDraftData';
import 'react';
import 'prop-types';
import 'classnames';
import 'react-dom';
import 'wix-rich-content-ui-components';
import './video-viewer.js';
import './reactPlayerWrapper.js';
import 'react-player';
import './constants.js';
import 'ricos-schema';
import 'wix-rich-content-common/dist/statics/schemas/plugin-video.schema.json';
import './get-video-source.js';
import './IframePlayer.js';
import './video-viewer-200c0e68.js';
import './style-inject.es-746bb8ed.js';
import './default-video-styles-ee165d52.js';
import './types.js';
import 'wix-rich-content-editor-common';

const createVideoData = (pluginData = {}, isRicosSchema = false) => {
  const videoData = isRicosSchema ? convertNodeDataToDraft(Node_Type.VIDEO, pluginData) : pluginData;
  return merge({}, DEFAULTS, videoData);
};

export { createVideoData };
//# sourceMappingURL=createVideoData.js.map
